<div class="p-4 md:p-8  min-h-screen   text-slate-600 dark:text-slate-300 overflow-x-hidden" (click)="closeDropdowns()">

    <!-- Header -->
    <div class="mb-5 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 animate-fade-in-up">
        <div>
            <h2 class="text-xl font-bold text-gray-800 dark:text-slate-100">
                {{ isEditMode ? 'แก้ไขรายละเอียดใบแจ้งหนี้' : 'สร้างใบแจ้งหนี้ (Create Invoice)' }}
            </h2>
            <p class="text-sm text-gray-500 dark:text-slate-400 mt-1">
                {{ isEditMode ? 'แก้ไขข้อมูลใบแจ้งหนี้ได้ทุกช่อง ยกเว้นลูกค้า' : 'ออกเอกสารใบแจ้งหนี้สำหรับลูกค้าทั่วไป' }}
            </p>
        </div>
        <div class="flex items-center gap-3 w-full md:w-auto">
            <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
                class="w-full md:w-auto px-5 py-2.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-[13px] font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 transition-colors shadow-sm cursor-pointer tracking-wide flex items-center justify-center gap-2">
                <span class="material-icons text-[18px]">history</span>
                ดูประวัติ
            </button>
            <button (click)="backToList()"
                class="w-full md:w-auto px-6 py-2.5 bg-white dark:bg-slate-800 border border-gray-200 bg-white dark:border-slate-700 rounded-xl text-[13px] font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors shadow-sm focus:outline-none cursor-pointer tracking-wide flex items-center justify-center gap-2">
                <span class="material-icons text-[18px]">arrow_back</span> กลับหน้ารายการ
            </button>
        </div>
    </div>

    <!-- Main Card -->
    <div class="bg-white dark:bg-slate-800 xl:rounded-xl shadow-[0_0_10px_0_rgba(0,0,0,0.05)] border border-gray-100 dark:border-slate-700 overflow-hidden relative animate-fade-in-up"
        style="animation-delay: 0.1s;">

        <div
            class="p-4 md:p-6 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 relative z-40 bg-slate-50/30 dark:bg-slate-900/30">

            <!-- Left Column -->
            <div class="space-y-5 md:space-y-6 flex flex-col justify-start">
                <div
                    class="space-y-4 md:space-y-5 bg-white dark:bg-slate-800 rounded-2xl p-4 md:p-5 border border-slate-100 dark:border-slate-700/60 shadow-sm relative z-50 h-max flex-1">
                    <h3
                        class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1 flex items-center gap-2">
                        <span class="material-icons text-sm">person</span>
                        ข้อมูลผู้รับ (Recipient Info)
                    </h3>

                    <div class="relative z-40">
                        <label
                            class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
                            ชื่อผู้รับ (Name) <span class="text-rose-500">*</span>
                        </label>
                        <div class="relative">
                            <div
                                class="absolute left-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-md flex items-center justify-center bg-slate-100 dark:bg-slate-700 text-slate-400">
                                <span class="material-icons text-[14px]">person_outline</span>
                            </div>
                            <input type="text" [(ngModel)]="name" placeholder="ระบุชื่อผู้รับ..."
                                [disabled]="isHeaderLocked"
                                class="w-full pl-11 pr-3 py-2 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-[13px] font-medium transition-all text-slate-700 dark:text-slate-200 disabled:opacity-60 disabled:cursor-not-allowed">
                        </div>
                    </div>

                    <div class="grid grid-cols-1 gap-5">
                        <div class="relative z-[60]">
                            <label
                                class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
                                ลูกค้า (Customer) <span class="text-rose-500">*</span>
                            </label>
                            <div class="relative group" (click)="$event.stopPropagation();">
                                <div class="relative">
                                    <div
                                        class="absolute left-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-md flex items-center justify-center bg-slate-100 dark:bg-slate-700 text-slate-400">
                                        <span class="material-icons text-[14px]">people</span>
                                    </div>
                                    <input type="text" [(ngModel)]="customerSearchText"
                                        (focus)="openDropdown = 'customers'" (blur)="closeDropdowns()"
                                        placeholder="-- เลือกลูกค้า --" [disabled]="isCustomerLocked"
                                        class="w-full pl-11 pr-10 py-2 bg-white dark:bg-slate-800 border-2 rounded-xl outline-none transition-all duration-200 focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-[13px] font-medium min-h-[40px] disabled:opacity-60 disabled:cursor-not-allowed"
                                        [ngClass]="openDropdown === 'customers' ? 'border-amber-400 dark:border-amber-500 ring-4 ring-amber-500/10 shadow-sm' : 'border-slate-200 dark:border-slate-700 hover:border-amber-400 dark:hover:border-amber-500'">
                                    <span
                                        class="absolute right-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 transition-transform duration-300 text-[18px] pointer-events-none"
                                        [ngClass]="{'rotate-180 text-amber-500': openDropdown === 'customers'}">expand_more</span>
                                </div>

                                <div *ngIf="openDropdown === 'customers'" (mousedown)="$event.preventDefault()"
                                    class="absolute z-[100] w-full mt-1.5 bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-slate-200/80 dark:border-slate-700/80 rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.15)] py-1.5 max-h-56 overflow-y-auto transform opacity-100 scale-100 transition-all origin-top custom-scrollbar animate-fade-in-up">
                                    <button *ngIf="filteredCustomers.length === 0" disabled
                                        class="w-full text-left px-3 py-2 text-[12px] text-slate-400 italic">ไม่พบข้อมูล</button>
                                    <button *ngFor="let option of customerOptions"
                                        (mousedown)="selectOption('customers', option.value); $event.preventDefault(); $event.stopPropagation();"
                                        class="w-full text-left px-3 py-2.5 text-[12px] transition-colors flex items-center justify-between group"
                                        [ngClass]="selectedCustomerId === option.value ? 'bg-amber-50/80 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 font-bold' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 font-medium'">
                                        <span class="truncate pr-2 block overflow-hidden text-ellipsis">{{ option.label
                                            }}</span>
                                        <span *ngIf="selectedCustomerId === option.value"
                                            class="material-icons text-[16px] text-amber-500 animate-scale-up flex-shrink-0">check_circle</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="relative z-[50]">
                            <label
                                class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
                                สถานที่ (Site) <span class="text-rose-500">*</span>
                            </label>
                            <div
                                class="w-full flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-900/50 border-2 border-slate-200 dark:border-slate-700 rounded-xl text-[13px] font-medium min-h-[40px]">
                                <div class="w-6 h-6 rounded-md flex items-center justify-center shadow-sm flex-shrink-0"
                                    [ngClass]="selectedSiteId ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400' : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
                                    <span class="material-icons text-[14px]">place</span>
                                </div>
                                <span class="truncate"
                                    [ngClass]="selectedSiteId ? 'text-slate-700 dark:text-slate-200 font-bold' : 'text-slate-400 dark:text-slate-500'">
                                    {{ selectedSiteName || 'กรุณาเลือก Site จาก Sidebar' }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="addresses.length > 0" class="relative z-[40] animate-fade-in">
                        <ng-container *ngTemplateOutlet="selectField; context: {
                            label: 'ที่อยู่ (Address)',
                            key: 'addresses',
                            options: addressOptions,
                            selected: selectedAddressId,
                            icon: 'home',
                            placeholder: '-- เลือกที่อยู่ --',
                            disabled: isHeaderLocked,
                            required: false
                        }"></ng-container>
                    </div>
                </div>
            </div>

            <!-- Right Column -->
            <div class="h-max space-y-5 md:space-y-6 flex flex-col justify-start">
                <div
                    class="space-y-4 md:space-y-5 bg-white dark:bg-slate-800 rounded-2xl p-4 md:p-5 border border-slate-100 dark:border-slate-700/60 shadow-sm relative overflow-visible z-50 h-max flex-1">
                    <h3
                        class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1 flex items-center gap-2">
                        <span class="material-icons text-sm">payments</span> ข้อมูลการชำระเงิน (Financial Info)
                    </h3>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                        <div class="relative z-40">
                            <label
                                class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">วันครบกำหนด
                                (Due Date)</label>
                            <div class="relative flex items-center">
                                <span
                                    class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px] pointer-events-none z-10">calendar_today</span>
                                <input type="text" [matDatepicker]="dueDatePicker" [(ngModel)]="dueDate"
                                    [disabled]="isHeaderLocked" (click)="!isHeaderLocked && dueDatePicker.open()"
                                    placeholder="วว/ดด/ปป" readonly
                                    class="w-full pl-9 pr-10 py-2 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-[13px] font-medium transition-all text-slate-700 dark:text-slate-200 disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer">
                                <mat-datepicker-toggle matIconSuffix [for]="dueDatePicker" [disabled]="isHeaderLocked"
                                    class="absolute right-1 text-slate-400 hover:text-amber-500 scale-90"></mat-datepicker-toggle>
                                <mat-datepicker #dueDatePicker panelClass="modern-yellow-datepicker"></mat-datepicker>
                            </div>
                        </div>

                        <div class="relative z-[50]">
                            <ng-container *ngTemplateOutlet="selectField; context: {
                                label: 'ประเภทการชำระ',
                                key: 'paymentTypes',
                                options: paymentTypeOptions,
                                selected: selectedFeeTypeId,
                                icon: 'account_balance_wallet',
                                placeholder: '-- เลือกประเภท --',
                                disabled: isHeaderLocked
                            }"></ng-container>
                        </div>
                    </div>

                    <div *ngIf="selectedFeeTypeId == 3" class="relative z-[45] animate-fade-in-up">
                        <ng-container *ngTemplateOutlet="selectField; context: {
                            label: 'ธนาคาร',
                            key: 'banks',
                            options: bankOptions,
                            selected: selectedBankId,
                            icon: 'account_balance',
                            placeholder: '-- เลือกธนาคาร --',
                                disabled: isHeaderLocked
                        }"></ng-container>
                    </div>

                    <!-- Bank Box mimicking tax invoice box style from revenue form -->
                    <div *ngIf="selectedFeeTypeId == 3 && selectedBank"
                        class="animate-fade-in-up mt-2 p-4 bg-gradient-to-br from-amber-50 to-orange-50/50 dark:from-amber-900/20 dark:to-orange-900/10 border-2 border-amber-400/50 dark:border-amber-700/50 rounded-2xl shadow-sm ring-4 ring-amber-500/5 flex items-start gap-4">
                        <div
                            class="w-10 h-10 rounded-xl bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 flex items-center justify-center shadow-sm shrink-0">
                            <span class="material-icons text-[20px]">account_balance</span>
                        </div>
                        <div class="flex flex-col">
                            <h3 class="text-sm font-bold text-amber-800 dark:text-amber-400 leading-tight">{{
                                selectedBank.bankName }}</h3>
                            <p class="text-[12px] text-slate-600 dark:text-slate-400 mt-1">ชื่อบัญชี: <span
                                    class="font-bold text-slate-800 dark:text-slate-200">{{ selectedBank.accountName
                                    }}</span></p>
                            <p class="text-[12px] text-slate-600 dark:text-slate-400">เลขที่บัญชี: <span
                                    class="font-bold text-amber-600 dark:text-amber-500 tracking-wider">{{
                                    selectedBank.accountNumber }}</span></p>
                        </div>
                    </div>

                    <div class="relative z-10 pt-2">
                        <label
                            class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">หมายเหตุ
                            (Remark)</label>
                        <textarea [(ngModel)]="remark" rows="2" placeholder="ระบุหมายเหตุเพิ่มเติม (ถ้ามี)" [disabled]="isHeaderLocked"
                            class="w-full px-3.5 py-2.5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl outline-none focus:ring-4 focus:ring-amber-500/10 focus:border-amber-400 dark:focus:border-amber-500 text-[13px] font-medium transition-all text-slate-700 dark:text-slate-200 resize-y hover:border-amber-300 dark:hover:border-slate-600"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <!-- Items Section -->
        <div class="border-t-2 border-slate-100 dark:border-slate-800 relative z-10 bg-white dark:bg-slate-800">
            <div class="px-6 py-4 flex justify-between items-center tracking-wide">
                <div>
                    <h3 class="text-[14px] font-bold text-slate-700 dark:text-slate-200 flex items-center gap-2">
                        <span class="material-icons text-amber-500 text-[18px]">list_alt</span> รายการสินค้า / บริการ
                    </h3>
                </div>
                <!-- Button imitating the Revenue form's add style -->
                <button (click)="openAddItemModal()" [disabled]="!isHeaderValid"
                    class="px-4 py-2 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-600 text-[12px] font-bold text-slate-600 dark:text-slate-300 hover:text-amber-600 hover:border-amber-400 dark:hover:text-amber-400 dark:hover:border-amber-500 rounded-xl shadow-sm transition-all focus:outline-none flex items-center gap-1.5 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                    <span class="material-icons text-[16px]">add</span> เพิ่มรายการ
                </button>
            </div>

            <div class="px-6 pb-6 overflow-x-auto">
                <table
                    class="w-full text-left border-collapse border border-slate-200 dark:border-slate-700 rounded-xl overflow-hidden shadow-sm shadow-slate-100/50 dark:shadow-none block sm:table">
                    <thead>
                        <tr class="bg-slate-50 dark:bg-slate-900/50 border-b border-slate-200 dark:border-slate-700">
                            <th
                                class="py-2.5 px-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest w-16 text-center">
                                #</th>
                            <th class="py-2.5 px-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                                รายละเอียด</th>
                            <th
                                class="py-2.5 px-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center w-24">
                                จำนวน</th>
                            <th
                                class="py-2.5 px-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right w-36">
                                ราคา (Base)</th>
                            <th
                                class="py-2.5 px-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right w-24">
                                VAT</th>
                            <th
                                class="py-2.5 px-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right w-32">
                                รวม</th>
                            <th
                                class="py-2.5 px-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center w-16">
                            </th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-100 dark:divide-slate-800/60 bg-white dark:bg-slate-800">
                        <tr *ngIf="items.length === 0">
                            <td colspan="7" class="py-12 text-center">
                                <div
                                    class="h-12 w-12 mx-auto bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-2">
                                    <span
                                        class="material-icons text-slate-300 dark:text-slate-600 text-[24px]">inbox</span>
                                </div>
                                <p class="text-[12px] font-bold text-slate-400">ยังไม่มีรายการ</p>
                            </td>
                        </tr>
                        <tr *ngFor="let item of items; let i = index"
                            class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-colors group">
                            <td class="py-3 px-4 text-center text-[12px] font-bold text-slate-400">{{ i + 1 }}</td>
                            <td class="py-3 px-4">
                                <p class="text-[13px] font-medium text-slate-700 dark:text-slate-200">{{
                                    item.description }}</p>
                            </td>
                            <td class="py-3 px-4 text-center">
                                <div
                                    class="inline-flex items-center justify-center min-w-[28px] h-6 bg-slate-100 dark:bg-slate-800 rounded text-[11px] font-bold text-slate-600 dark:text-slate-300">
                                    {{ item.quantity }}
                                </div>
                            </td>
                            <td class="py-3 px-4 text-right text-[12px] text-slate-500 dark:text-slate-400">{{
                                getItemBaseTotal(item) | number:'1.2-2' }}</td>
                            <td class="py-3 px-4 text-right text-[12px] text-rose-500">{{ getItemVatTotal(item) |
                                number:'1.2-2' }}</td>
                            <td class="py-3 px-4 text-right text-[13px] font-bold text-slate-800 dark:text-slate-200">{{
                                getItemGrandTotal(item) | number:'1.2-2' }}</td>
                            <td class="py-3 px-4 text-center">
                                <div class="flex items-center justify-center gap-1">
                                    <button type="button" (click)="openEditItemModal(i)" title="แก้ไขรายการ"
                                        class="w-7 h-7 rounded-full flex items-center justify-center text-slate-300 hover:bg-amber-50 hover:text-amber-500 dark:hover:bg-amber-500/20 dark:hover:text-amber-400 transition-colors cursor-pointer">
                                        <span class="material-icons text-[14px]">edit</span>
                                    </button>
                                    <button type="button" (click)="removeItem(i)" title="ลบรายการ"
                                        class="w-7 h-7 rounded-full flex items-center justify-center text-slate-300 hover:bg-rose-50 hover:text-rose-500 dark:hover:bg-rose-500/20 dark:hover:text-rose-400 transition-colors cursor-pointer">
                                        <span class="material-icons text-[14px]">delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div
            class="px-4 md:px-6 py-5 bg-slate-50/50 dark:bg-slate-800/50 border-t border-slate-100 dark:border-slate-800/50 flex flex-col md:flex-row justify-between items-center gap-4 relative z-10">
            <!-- Summary aligned with the right side -->
            <div class="flex items-center gap-4 text-white overflow-x-auto w-full md:w-auto h-12">
                <div class="flex items-center gap-4 md:gap-5 ml-auto text-right">
                    <div class="flex flex-col">
                        <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-0.5">รวม
                            (Sub)</span>
                        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-300">{{ subTotal |
                            number:'1.2-2' }}</span>
                    </div>
                    <div class="w-px h-6 bg-slate-300 dark:bg-slate-700"></div>
                    <div class="flex flex-col">
                        <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-0.5">VAT
                            {{ vatSetting.rateLabel() }}%</span>
                        <span class="text-[13px] font-bold text-rose-500">{{ vatAmount | number:'1.2-2' }}</span>
                    </div>
                    <div class="w-px h-6 bg-slate-300 dark:bg-slate-700"></div>
                    <div class="flex flex-col pr-2">
                        <span
                            class="text-[10px] font-bold text-amber-600 dark:text-amber-500 uppercase tracking-widest mb-0.5">ยอดสุทธิ
                            (Total)</span>
                        <span class="text-lg font-black text-amber-500 tracking-tight leading-none">{{ total |
                            number:'1.2-2' }} <span class="text-[12px] font-bold">฿</span></span>
                    </div>
                </div>
            </div>

            <!-- Align action buttons like revenue form -->
            <div
                class="w-full md:w-auto flex justify-end gap-3 mt-2 md:mt-0 pt-3 border-t border-slate-200 dark:border-slate-700 md:pt-0 md:border-none">
                <button (click)="backToList()"
                    class="w-full md:w-auto px-6 py-2.5 bg-white dark:bg-slate-700 border-2 border-slate-200 dark:border-slate-600 rounded-xl text-[13px] font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors shadow-sm focus:outline-none cursor-pointer tracking-wide">
                    ยกเลิก
                </button>
                <button (click)="submit()" [disabled]="items.length === 0 || isLoading"
                    class="w-full md:w-auto px-8 py-2.5 bg-amber-400 hover:bg-amber-500 text-white rounded-xl text-[13px] font-bold shadow-lg shadow-amber-300/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer transform hover:-translate-y-0.5 active:translate-y-0 tracking-wide relative overflow-hidden group disabled:opacity-50 disabled:cursor-not-allowed">
                    <div
                        class="absolute inset-0 w-full h-full bg-white/20 -translate-x-full group-hover:animate-shimmer skew-x-12">
                    </div>
                    <span *ngIf="isLoading"
                        class="w-4 h-4 border-2 border-white/60 border-t-white rounded-full animate-spin"></span>
                    <span class="material-icons text-[18px]" *ngIf="!isLoading">save</span>
                    {{ isLoading ? 'กำลังบันทึก...' : (isEditMode ? 'บันทึกการแก้ไข' : 'บันทึกใบแจ้งหนี้') }}
                </button>
            </div>
        </div>

    </div>

</div>

<!-- Reusable Dropdown Template -->
<ng-template #selectField let-label="label" let-key="key" let-options="options" let-selected="selected" let-icon="icon"
    let-placeholder="placeholder" let-disabled="disabled" let-required="required">
    <div class="relative w-full">
        <label class="block text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5">
            {{ label }} <span *ngIf="required !== false" class="text-rose-500">*</span>
        </label>
        <div class="relative group" (click)="$event.stopPropagation();">
            <button type="button" (click)="!disabled && toggleDropdown(key, $event)" (blur)="closeDropdowns()"
                [disabled]="disabled"
                class="w-full flex items-center justify-between px-3 py-2 bg-white dark:bg-slate-800 border-2 rounded-xl text-left transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-amber-500/10 shadow-[0_2px_10px_-3px_rgba(0,0,0,0.05)] text-[13px] font-medium min-h-[40px]"
                [ngClass]="{
                    'border-slate-200 dark:border-slate-700 hover:border-amber-400 dark:hover:border-amber-500': openDropdown !== key && !disabled,
                    'border-amber-400 dark:border-amber-500 ring-4 ring-amber-500/10 shadow-sm': openDropdown === key,
                    'bg-slate-50 border-slate-100 dark:border-slate-700/50 text-slate-400 cursor-not-allowed opacity-70': disabled,
                    'text-slate-700 dark:text-slate-200': selected !== null && !disabled,
                    'text-slate-400 dark:text-slate-500': selected === null && !disabled
                }">
                <div class="flex items-center gap-2 limit-text w-full">
                    <div class="w-6 h-6 rounded-md flex items-center justify-center transition-colors shadow-sm flex-shrink-0"
                        [ngClass]="selected !== null ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400' : 'bg-slate-100 dark:bg-slate-700 text-slate-400'">
                        <span class="material-icons text-[14px]">{{ icon }}</span>
                    </div>
                    <span class="truncate block overflow-hidden text-ellipsis whitespace-nowrap"
                        style="max-width: calc(100% - 24px);">{{ getOptionName(key, selected) || placeholder }}</span>
                </div>
                <span
                    class="material-icons text-slate-400 transition-transform duration-300 text-[18px] ml-1 flex-shrink-0"
                    [ngClass]="{'rotate-180 text-amber-500': openDropdown === key}">expand_more</span>
            </button>

            <div *ngIf="openDropdown === key && !disabled" (mousedown)="$event.preventDefault()"
                class="absolute z-[100] w-full mt-1.5 bg-white/95 dark:bg-slate-800/95 backdrop-blur-xl border border-slate-200/80 dark:border-slate-700/80 rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.15)] py-1.5 max-h-56 overflow-y-auto transform opacity-100 scale-100 transition-all origin-top custom-scrollbar animate-fade-in-up">
                <button *ngIf="!options || options.length === 0" disabled
                    class="w-full text-left px-3 py-2 text-[12px] text-slate-400 italic">
                    ไม่มีข้อมูล
                </button>
                <button *ngFor="let option of options"
                    (mousedown)="selectOption(key, option.value); $event.preventDefault(); $event.stopPropagation();"
                    class="w-full text-left px-3 py-2.5 text-[12px] transition-colors flex items-center justify-between group"
                    [ngClass]="{
                        'bg-amber-50/80 dark:bg-amber-950/20 text-amber-700 dark:text-amber-400 font-bold': selected === option.value,
                        'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-slate-800 dark:hover:text-slate-100 font-medium': selected !== option.value
                    }">
                    <span class="truncate pr-2 block overflow-hidden text-ellipsis">{{ option.label }}</span>
                    <span *ngIf="selected === option.value"
                        class="material-icons text-[16px] text-amber-500 animate-scale-up flex-shrink-0">check_circle</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!-- Modal for adding items -->
<app-modal-invoice-add-detail *ngIf="isAddItemModalOpen" [feeList]="invoiceFeeList" (close)="closeAddItemModal()"
    [editItem]="editingItemIndex === null ? null : items[editingItemIndex]"
    (save)="handleModalSave($event)">
</app-modal-invoice-add-detail>

<!-- Confirmation Modal before Save -->
<app-pss-confirm-modal *ngIf="isConfirmSaveModalOpen"
    [title]="isEditMode ? 'ยืนยันการแก้ไขรายละเอียด?' : 'ยืนยันการสร้างใบแจ้งหนี้?'"
    [message]="isEditMode ? 'คุณต้องการยืนยันการแก้ไขข้อมูลใบแจ้งหนี้' : 'คุณต้องการยืนยันการบันทึกข้อมูลและออกใบแจ้งหนี้สำหรับลูกค้า'"
    [highlight]="getOptionName('customers', selectedCustomerId)" confirmLabel="ยืนยัน" cancelLabel="ยกเลิก"
    variant="warning" icon="save" [showIrreversibleNote]="false" (confirm)="confirmSubmit()"
    (cancel)="isConfirmSaveModalOpen = false">
</app-pss-confirm-modal>

<!-- Full-screen Loading Overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && editInvoiceId"
  [entityType]="activityEntityTypes.Invoice"
  [entityId]="editInvoiceId"
  title="ประวัติใบแจ้งหนี้"
  [subtitle]="'#' + editInvoiceId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
